type TReplaceableText = string | ((text: string) => string);

/** Общий интерфейс для свойств страниц бандла */
export type IBundlePageProps =
  | { [x: string]: string }
  | {
      title: string | TReplaceableText;
      meta: {
        name: string;
        content: string | TReplaceableText;
        imageSize?: { width: number; height: number };
      }[];
      href: string;
    };

/** Пока выполняет роль кеша для свойств страницы */
export class PagesPropsCache {
  private cache: Map<string, IBundlePageProps> = new Map();
  private initialized = false;
  private defaultHref?: string;

  constructor(defaultCache?: IBundlePageProps[], defaultHref?: string) {
    this.defaultHref = defaultHref;
    if (defaultCache) {
      this.setCache(defaultCache);
    }
  }

  public setCache(cache: IBundlePageProps[]) {
    if (this.initialized) return;
    if (Array.isArray(cache) && cache.length > 0) {
      cache.forEach((p) => {
        this.cache.set(p.href, p);
      });

      this.initialized = true;
    }
  }

  public getProps(href: string) {
    if (this.initialized && this.cache.has(href)) {
      return this.cache.get(href);
    }

    return this.defaultHref ? this.cache.get(this.defaultHref) : undefined;
  }
}
